import { Dispatch } from '@reduxjs/toolkit';
import { resetSession } from '../../store';
import { api } from '../../services/api.service';
import { api as anamneseApi } from '../../services/anamnese.api.service';
import { resetMyFilesCache } from '../../pages/MyFilesV2/viewModel';
import { resetHomeCache } from '../../pages/Journeys/viewModel';
import { resetPrescriptionRenewalPendingState } from '../../components/pages/MyFilesV2/PrescriptionRenewal/viewModel';

/**
 * clear cache and reset user session
 */
export const resetUserSession = (dispatch: Dispatch) => {
  dispatch(resetSession());
  dispatch(api.util.resetApiState());
  dispatch(anamneseApi.util.resetApiState());
  resetMyFilesCache();
  resetHomeCache();
  resetPrescriptionRenewalPendingState();
};
